import './Area.scss';
import Button from "react-bootstrap/Button";
import React from "react";

const AreaComponent = ({area}) => {
    let image = area.image;
    let logo = null;
    if (area.logo !== null)
        logo = <div className={"area-logo"}><img src={global.getImage(area.logo)}/></div>

    return (
        <div className="area-container">
            <div className="area-image"
                 style={{backgroundImage: `url(${global.getImage(image)})`}}
            >
                {logo}

                <span className={"area-title"}>{area.name}</span>

                <div className="area-bottom">
                    <span>{area.address}, {area.number} {area.city} ({area.cap})</span>
                    <Button variant={"success"} size="sm">Mostra info</Button>
                </div>
            </div>
        </div>
    );
};

export default AreaComponent;
